import { render, staticRenderFns } from "./HelpCenterManagement.vue?vue&type=template&id=d03c2b90&scoped=true&"
import script from "./HelpCenterManagement.vue?vue&type=script&lang=js&"
export * from "./HelpCenterManagement.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterManagement.vue?vue&type=style&index=0&id=d03c2b90&lang=less&scoped=true&"
import style1 from "./HelpCenterManagement.vue?vue&type=style&index=1&id=d03c2b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03c2b90",
  null
  
)

export default component.exports